// Image page Vue component

/* global console require */

import Vue from "vue";
import $ from "jquery";
import imageName from "imageName";
import discussion from "../archive/discussion.js";
import { trans } from "common/translate.js";

new Vue({
  data() {
    return {
      discussionData: [],
      discussionLoaded: false,
      imageId: imageName,
      trans,
    };
  },

  created() {
    this.fetchComments();
  },

  methods: {
    fetchComments() {
      console.log("Fetching comments");
      $.get("/api/disqus", {
        endpoint: "/threads/listPosts.json",
        order: "asc",
        thread: `ident:image/${this.imageId}`
      })
        .done(data => {
          this.discussionData = data;
          this.discussionLoaded = true;
        })
        .fail(() => console.log("Failed to fetch comments data"));
    }
  },

  computed: {
    discussionTitle() {
      return `${this.trans("Discussion")}` + (this.discussionLoaded ? ` (${this.discussionData.response.length})` : "");
    },
  },

  components: {
    discussion
  },

  template: require("./image-page.html"),
  el: "#image-comments",
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/image/image-page.js